<template>
  <div>
    <Header></Header>
    <div id="main">

      <div class="container" v-if="project">
        <div class="row">
          <div class="col-md-12">

            <h1>{{project.Info.title}}</h1>

            <div class="section-tab">
              <ul>
                <li class="active">1 - Quanto quero doar</li>
                <li>2 - Meios de pagamento</li>
                <li>3 - Compartilhar</li>
              </ul>
            </div>

            <div class="donation-values row" v-if="hasOptionalValues">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == project.optionalValues.optionalValue1 }"
                    href="" v-on:click.stop.prevent="changeDonationValue((project.optionalValues.optionalValue1) ? project.optionalValues.optionalValue1 : 20)">
                    {{ project.optionalValues.optionalValue1 ? 'R$' + project.optionalValues.optionalValue1 : 'R$20' }}</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == project.optionalValues.optionalValue2 }"
                    href="" v-on:click.stop.prevent="changeDonationValue((project.optionalValues.optionalValue2) ? project.optionalValues.optionalValue2 : 25)">
                    {{ project.optionalValues.optionalValue2 ? 'R$' + project.optionalValues.optionalValue2 : 'R$25' }}</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == project.optionalValues.optionalValue3 }"
                    href="" v-on:click.stop.prevent="changeDonationValue((project.optionalValues.optionalValue3) ? project.optionalValues.optionalValue3 : 50)">
                    {{ project.optionalValues.optionalValue3 ? 'R$' + project.optionalValues.optionalValue3 : 'R$50' }}</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == project.optionalValues.optionalValue4 }"
                    href="" v-on:click.stop.prevent="changeDonationValue((project.optionalValues.optionalValue4) ? project.optionalValues.optionalValue4 : 100)">
                    {{ project.optionalValues.optionalValue4 ? 'R$' + project.optionalValues.optionalValue4 : 'R$100' }}</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-14 col-lg-4">
                  <input v-money="money" type="text" class="form-control" v-model="donationValueText"
                  v-on:keyup="changeDonationValue(null)" placeholder="Outro valor" />
                </div>
            </div>

            <div class="donation-values row" v-else>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == 20}" href="" v-on:click.stop.prevent="changeDonationValue(20)">R$20</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == 25}" href="" v-on:click.stop.prevent="changeDonationValue(25)">R$25</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == 50}" href="" v-on:click.stop.prevent="changeDonationValue(50)">R$50</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-2">
                  <a :class="{active: donationValue == 100}" href="" v-on:click.stop.prevent="changeDonationValue(100)">R$100</a>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-14 col-lg-4">
                  <input v-money="money" type="text" class="form-control" v-model="donationValueText"
                  v-on:keyup="changeDonationValue(null)" placeholder="Outro valor" />
                </div>
            </div>

            <div v-if="project.Costs && project.Costs.length > 0" class="donation-values row">
              <h4>Como você pode ajudar este projeto:</h4>
              <div v-for="(cost, c) in project.Costs" class="col-md cost" :key="c" @click="changeDonationValueText(cost.value)">
                <span>{{cost.title}}</span>
                <p>R$ {{cost.value}}</p>
                <span class="description">{{ cost.description }}</span>
              </div>
            </div>

            <div class="donation-type">
              <h2>Escolha o tipo de doação</h2>
              <div class="types row">
                <div class="col-md-6">
                  <a :class="{active: donationType == 'single'}" href="" v-on:click.stop.prevent="changeDonationType('single')">Única</a>
                </div>
                <div class="col-md-6">
                  <a :class="{active: donationType == 'monthly'}" href="" v-on:click.stop.prevent="changeDonationType('monthly')">Recorrente</a>
                </div>
              </div>
              <div class="periods row" v-if="donationType == 'monthly'">
                <div class="col-md-4">
                  <a :class="{active: donationPeriod == 12}" v-on:click.stop.prevent="changeDonationPeriod(12)" href="">1 ano</a>
                </div>
                <div class="col-md-4">
                  <a :class="{active: donationPeriod == 24}"  v-on:click.stop.prevent="changeDonationPeriod(24)" href="">2 anos</a>
                </div>
                <div class="col-md-4">
                  <a :class="{active: donationPeriod == 36}"  v-on:click.stop.prevent="changeDonationPeriod(36)" href="">3 anos</a>
                </div>
              </div>
            </div>

            <div class="donation-form">
              <form method="POST" @submit="makeDonation">
                <div class="form-group col-md-6">
                  <label>Seu nome</label>
                  <input v-if="user" type="text" class="form-control" :value="(user.Info) ? user.Info.fullname : user.username" readonly/>
                  <input required v-else type="text" class="form-control" v-model="name"/>
                  <div class="form-checkbox">
                    <input id="anonymous" type="checkbox" v-model="donationAnonymous" :value="true" />
                    <label for="anonymous">Doação anônima</label>
                  </div>
                </div>

                <div class="form-group col-md-6">
                  <label>E-mail</label>
                  <input v-if="user && !user.isFacebookUser" type="text" class="form-control" :value="user.Info.email" readonly/>
                  <input required v-else type="text" class="form-control" v-model="email"/>
                  <div class="form-checkbox">
                    <input type="checkbox" v-model="donationNewsletter" :value="true"/>
                    Assine nossa newsletter e ajude a fazer a diferença
                  </div>
                </div>

                <div class="form-group col-md-12">
                  <label>Mensagem para o projeto (opcional)</label>
                  <textarea v-model="donationMessage" class="form-control"></textarea>
                </div>
                <div v-if="showMsg" class="alert alert-danger alert-dismissible fade show" role="alert">
                    {{msg}}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Fechar" @click.stop.prevent="hideMsg()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="btn-payment">
                  <button class="btn">Fazer pagamento</button>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>

    </div>
    <Footer></Footer>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>

import Header from './includes/Header'
import Footer from './includes/Footer'
import auth from '../services/auth'
import Loading from './includes/Loading'
import Functions from '../utils/functions'
import { API } from '../services/api'
import {VMoney} from 'v-money'

export default {
  name: 'Donation',
  components: {
    Header,
    Footer,
    Loading
  },
  directives: {money: VMoney},
  data () {
    return {
      loading: true,
      project: null,
      name: '',
      email: '',
      donations: [],
      donationType: null,
      donationValue: 0,
      donationPeriod: 12,
      donationValueText: null,
      donationMessage: null,
      donationAnonymous: false,
      donationNewsletter: false,
      hasOptionalValues: false,
      minimumValue: 20,
      user: null,
      msg: '',
      showMsg: false,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  created(){
    this.loadProfile();
    this.loadProject();
  },
  mounted(){

  },
  methods: {
    loadProfile(){
      if(auth.isAuth()){
        this.$http.get(API.Profile.profile, {headers: auth.getHeaders()}).then((response) => {
          this.user = response.body.user;
        }, (err) => {
          this.$router.push('/project/' + this.$route.params.slug);
        });
      }
    },
    loadDonations(){
      if(auth.isAuth()){
        this.$http.get(API.Profile.donations, {headers: auth.getHeaders()}).then((result) => {
          this.donations = result.body.donations.filter((d) => {
            return d.ProjectId == this.project.ProjectId && d.type == 'monthly' && d.paymentStatus == 'paid';
          });
        });
      }
    },
    loadProject(){
      this.$http.get(API.Projects.getProject + this.$route.params.slug).then((res) => {
        this.project = res.body[0]
        this.minimumValue = (this.project.minimumValue) ? this.project.minimumValue : 20;
        this.loading = false;
        console.log(this.project)
        if(this.project.optionalValues){
          this.hasOptionalValues = true;
        }
        this.loadDonations();
      })
    },
    changeDonationValue(value){
      if(value){
        this.donationValueText = null;
      }
      this.donationValue = value;
      this.$scrollTo('.donation-type', 500, {offset: -60});
    },
    changeDonationValueText(text){
      this.donationValueText = (text* 100);
      this.$scrollTo('.donation-type', 500, {offset: -60});
    },
    changeDonationType(type){
      this.donationType = type;
      this.$scrollTo('.donation-form', 500, {offset: -70});
    },
    changeDonationPeriod(period){
      this.donationPeriod = period;
    },
    makeDonation(e){
      e.preventDefault();
      this.loading = true;
      if(this.validate()){
        var donationValueText = parseFloat(this.donationValueText.replace("R$ ", "").replace(".", "").replace(",", "."));
        var donationValue = (donationValueText > 0.0) ?
        donationValueText : this.donationValue;
        if(auth.isAuth() && this.donations.length > 0 && this.donationType == 'monthly'){
          this.loading = false;
          this.msg = 'Você já possui uma doação recorrente ativa para este projeto!';
          this.showMsg = true;
          return;
        }
        if(donationValue && this.donationType){
          if(donationValue >= this.minimumValue){
            this.$http.post(API.Projects.registerDonation, {
              ProjectId: this.project.ProjectId,
              UserId: (this.user) ? this.user.UserId : null,
              name: (this.user) ? this.user.name : this.name,
              email: (this.user) ? this.user.email : this.email,
              donationType: this.donationType,
              donationValue: donationValue,
              donationPeriod: (this.donationType == 'monthly') ? this.donationPeriod : null,
              message: this.donationMessage,
              anonymous: this.donationAnonymous
            }, {headers: auth.getHeaders()}).then((res) => {
              this.loading = false;
              var DonationId = res.body.DonationId;
              this.$router.push('/project/donation/method/' + DonationId);
            }, (err) => {

            });
          }else{
            this.loading = false;
            this.msg = 'O valor mínimo de doação definido pelo Projeto Social é de ' + Functions.numberToReal(this.minimumValue);
            this.showMsg = true;
          }
        }else{
          this.loading = false;
          this.msg = 'Você deve definir um valor e o tipo de doação!';
          this.showMsg = true;
        }
      }else{
        this.loading = false;
      }
    },
    validate()
    {
      if(!auth.isAuth()){
        if(!this.name || this.name == ''){
          this.msg = 'Você deve informar seu nome.';
          this.showMsg = true;
          return false;
        }
        if(!this.email || this.email == ''){
          this.msg = 'Você deve informar seu e-mail.';
          this.showMsg = true;
          return false;
        }
      }
      return true;
    },
    hideMsg(){
      this.msg = "";
      this.showMsg = false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


  h1{
    text-align: center;
    font-family: RalewayBold;
    color: #00ae39;
    @media screen and(max-width: 767px){
      font-size: 26px;
    }
  }

  .section-tab{
    width: 100%;
    margin-top: 20px;



    ul{
      list-style: none;
      padding: 0;
      padding-top: 20px;
      border-bottom: thin solid #ccc;

      li{
        display: inline-block;
        padding-bottom: 10px;
        margin-right: 20px;
        font-size: 20px;
        cursor: default;
        @media screen and(max-width: 767px){
          display: none;
          margin-right: 0px;
        }
        &.active{
          color: #00ae39;
          font-weight: bold;
          border-bottom: 3px solid #00ae39;
          @media screen and(max-width: 767px){
            display: block;
            text-align: center;;
          }
        }
      }
    }
  }

  .donation-values{
    margin-top: 10px;
    padding: 60px;
    @media screen and(max-width: 767px){
      padding: 20px;
    }
    border-bottom: thin solid #ccc;
    text-align: center;

    h4{
      text-align: center;
      font-family: RalewayRegular;
      width: 100%;
    }

    a{
      display: inline-block;
      background-color: #00ae39;
      color: #fff;
      padding: 10px;
      padding-left: 20px;
      padding-right: 20px;
      margin-right: 40px;
      border-radius: 5px;
      font-size: 28px;
      text-decoration: none;

      @media screen and(max-width: 991px){
        margin-right: 0px;
        margin-top: 10px;
      }

      &.active{
        background-color: #ccc;
      }
    }

    input{
      display: inline-block;
      width: 300px;
      height: 30px;
      padding: 30px;
      font-size: 30px;
      @media screen and(max-width: 991px){
        width: 200px;
        margin-top: 20px;
      }
    }

    .cost{
      cursor: pointer;
      padding: 5px 5px;
      p{
        font-family: RalewayBold;
        font-size: 22px;
      }

      &:hover{
        border: thin solid #00ae39;
        border-radius: 10px;
      }
    }
  }

  .donation-type{
    padding: 60px;
    border-bottom: thin solid #ccc;
    h2{
      text-align: center;
      font-family: RalewayBold;
    }
    .types{
      margin-top: 20px;
      text-align: center;
      a{
        display: inline-block;
        width: 100%;
        background-color: #00ae39;
        color: #fff;
        padding: 10px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 5px;
        font-size: 28px;
        text-decoration: none;
        @media screen and(max-width: 767px){
          margin-top: 10px;
        }
        &.active{
          background-color: #ccc;
        }

        &:first-child{
          margin-right: 40px;
        }
      }
    }

    .periods{
      margin-top: 30px;
      text-align: center;
      a{
        width: 100%;
        padding: 10px;
        padding-left: 20px;
        padding-right: 20px;
        border-radius: 5px;
        font-size: 24px;
        background-color: #00ae39;
        color: #fff;
        text-decoration: none;

        &.active{
          background-color: #ccc;
        }
      }
    }
  }

  .donation-form{
    padding: 60px;
    @media screen and(max-width: 767px){
      padding: 20px;
    }

    input{
      font-size: 20px;
    }

    .form-checkbox{
      margin-top: 10px;
    }

    textarea{
      resize: none;
      padding: 20px;
      font-size: 15px;
    }

    .btn-payment{
      width: 100%;
      text-align: center;
      margin-top: 40px;

      button{
        width: 300px;
        padding: 15px;
        font-size: 28px;
        border-radius: 5px;
        color: #fff;
        background-color: #fd6721;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Donation.vue